'use client';

import { Turnstile, type TurnstileInstance } from '@marsidev/react-turnstile';
import { forwardRef, useImperativeHandle, useRef } from 'react';

export type TurnstileWidgetHandle = { reset: () => void };

type Props = { onToken: (token: string | null) => void };

export const TurnstileWidget = forwardRef<TurnstileWidgetHandle, Props>(function TurnstileWidget(
  { onToken },
  ref
) {
  const innerRef = useRef<TurnstileInstance | null>(null);
  const siteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;
  const isProd = process.env.NODE_ENV === 'production';

  useImperativeHandle(
    ref,
    () => ({
      reset: () => {
        innerRef.current?.reset();
        onToken(null);
      },
    }),
    [onToken]
  );

  if (!siteKey && isProd) {
    return (
      <div role="alert" className="text-xs text-red-500" aria-label="Verificación anti-spam">
        Turnstile site key missing.
      </div>
    );
  }

  if (!siteKey && !isProd) {
    onToken('dev-bypass');
    return (
      <div className="text-xs text-[#6b6e68] font-mono" aria-label="Verificación anti-spam">
        DEV BYPASS — Turnstile desactivado
      </div>
    );
  }

  return (
    <div aria-label="Verificación anti-spam">
      <Turnstile
        ref={innerRef}
        siteKey={siteKey!}
        options={{ theme: 'light', appearance: 'interaction-only', responseField: false }}
        onSuccess={(token) => onToken(token)}
        onError={() => onToken(null)}
        onExpire={() => onToken(null)}
      />
    </div>
  );
}) as React.ForwardRefExoticComponent<Props & React.RefAttributes<TurnstileWidgetHandle>>;
